import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'

import * as rotativeInventoryActions from 'action/rotativeInventory'
import * as reportActions from 'action/report'

import Checkbox from 'component/Checkbox/newCheckbox'

import CommonReport from 'component/commonReport/CommonReport'
import columns from 'component/rotativeInventoryNew/columns'
import applyMask from 'component/report/utils/Formatter'
import moment from 'moment'
import { renderToastWarn } from 'utils/ToastUtils'

let signalController;

const getRestoredFiltersFromLocation = (location) => {
  const query = (location && location.query) || {}
  const dtStart = query.riDtStart
  const dtEnd = query.riDtEnd

  if (!dtStart || !dtEnd) return null

  const mStart = moment(dtStart, 'DD/MM/YYYY', true)
  const mEnd = moment(dtEnd, 'DD/MM/YYYY', true)
  if (!mStart.isValid() || !mEnd.isValid()) return null

  const parseCsv = (value) =>
    value
      ? String(value)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
      : []

  const idBranches = parseCsv(query.riIdBranches)
  const lsSections = parseCsv(query.riLsSections)
    .map((value) => Number(value))
    .filter((value) => !Number.isNaN(value))
  const integratedStatusNumber = Number(query.riIntegratedStatus)

  return {
    idBranches,
    lsSections,
    cdLm: query.riCdLm ? String(query.riCdLm) : '',
    dtPeriod: [mStart.format(), mEnd.format()],
    integratedStatus: Number.isNaN(integratedStatusNumber) ? 2 : integratedStatusNumber,
    includeLot: String(query.riIncludeLot || '0') === '1',
  }
}

class TotalAccuracy extends React.Component {
  constructor(props) {
    super(props)
    const restoredFilters = getRestoredFiltersFromLocation(props.location)

    this.state = {
      formData: {},
      includeLot: restoredFilters ? !!restoredFilters.includeLot : false,
      updateReport: false,
      restoredFilters,
    }
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    fetchRotativeInventory: PropTypes.func,
    error: PropTypes.object,
    count: PropTypes.number.isRequired,
    records: PropTypes.array.isRequired,
    fetchReports: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    fetchFluxReport: PropTypes.func.isRequired,
    v2fetchRotativeInventory: PropTypes.func,
    location: PropTypes.object,
  }

  get formFields() {
    const { translate } = this.props
    const { restoredFilters } = this.state

    const initialDateRange = restoredFilters && restoredFilters.dtPeriod
      ? [moment(restoredFilters.dtPeriod[0]), moment(restoredFilters.dtPeriod[1])]
      : null

    return [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('field.store'),
        help_text: translate('totalAccuracy.store'),
        required: true,
        initial: restoredFilters ? restoredFilters.idBranches : [],
      },
      {
        type: 'sections',
        name: 'lsSections',
        help_text: translate('irc.choose-section'),
        label: translate('section'),
        required: false,
        initial: restoredFilters ? restoredFilters.lsSections : [],
      },
      {
        type: 'text',
        name: 'cdLm',
        help_text: translate('mobile.hint.lm'),
        label: translate('field.lm.hint'),
        required: false,
        initial: restoredFilters ? restoredFilters.cdLm : '',
        attrs: {
          maxLength: 8,
          minLength: 8,
          mask: '99999999',
        },
      },
      {
        type: 'date_range',
        name: 'dtPeriod',
        label: translate('field.period.hint'),
        help_text: translate('totalAccuracy.dtYear.filter'),
        required: true,
        initial: restoredFilters ? restoredFilters.dtPeriod : [],
        attrs: {
          initialValue: initialDateRange,
        },
      },

      {
            type: 'radio_group',
            name: 'integratedStatus',
            label: '',
            translate: true,
            title: "",

            required: false,
            initial: restoredFilters ? restoredFilters.integratedStatus : 2,
            options: [
              { value: 1, label: 'stock.adjustment.done.integrated' },
              { value: 3, label: 'stock.adjustment.done.notIntegrated' },
              { value: 2, label: 'stock.adjustment.done.all' },
            ],
          },
    ]
  }

  get columns() {
    const { includeLot } = this.state
    const { translate } = this.props

    return columns.reduce((reduced, col, idx) => {
      const { field, fixed, headerLabel, align, customWidth, render } = col
      if (!render || (idx === 6 && !includeLot)) return reduced
      reduced[field] = {
        fixed,
        align,
        customWidth,
        disableOrer: false,
        label: translate(headerLabel),
      }
      return reduced
    }, {})
  }

  get rows() {
    const { includeLot } = this.state
    const { records, translate } = this.props

    return (records || []).map((record) =>
      columns.reduce((reduced, col, idx) => {
        const { type, render, field, headerLabel } = col
        if (!render || (idx === 6 && !includeLot)) return reduced
        reduced[field] =
          record[field] || record[field] === 0
            ? applyMask(type, record[field], translate, headerLabel, record.numHouses)
            : '-'
        return reduced
      }, {})
    )
  }

  onSubmit = (data, successCallback) => {
    const { includeLot } = this.state
    const {
      error,
      v2fetchRotativeInventory,
      auth: {
        user: { dsToken },
      },
    } = this.props

    const [dtStart, dtEnd] = data.dtPeriod
    data = {
      ...data,
      includeLot: includeLot ? 1 : 0,
      dtStart: moment(dtStart).format('DD/MM/YYYY'),
      dtEnd: moment(dtEnd).format('DD/MM/YYYY'),
      size: 10,
      limit: 10,
      hasPagination: true,
    }

    this.setState({ formData: data, updateReport: false })
    delete data.dtPeriod

    signalController = new AbortController();

    v2fetchRotativeInventory(dsToken, data, (reportData) => {

      successCallback({
        data: reportData.resultList,
        total: reportData.pages.totalCount
      })
    }, (err) => {
      console.log("err: ", err)
      renderToastWarn(error)
    }, signalController)

  }

  onExport = (successCallback) => {
    const { formData, includeLot } = this.state
    signalController = new AbortController();
    const {
      fetchFluxReport,
      translate,
      auth: {
        user: { dsToken },
      },
    } = this.props



    const formDataFieldsFormated = {
      ...formData,
      includeLot: includeLot ? 1 : 0,
      cdSection: null,
      idRegions: [],
      ruptureIrc: false,
      order: "dtInventory",
      orderDirection: "asc",
    }

    fetchFluxReport(dsToken, { tpReport: 47 }, formDataFieldsFormated, translate,signalController).then(() =>
      successCallback(true)
    )
  }

  render() {
    const { translate, auth } = this.props
    const { updateReport, restoredFilters } = this.state
    const ids = (this.props.records || []).map((item) =>
      item.idInventory ||
      item.idInventoryCriteria ||
      item.idIrcSupply ||
      item.id ||
      item.codeProcess ||
      ''
    )
    return (
      <CommonReport
        initialFormData={restoredFilters}
        eyeIcon={true}
        user={auth.user}
        idsList={ids}
        translate={translate}
        title={translate('rotativeInventory.stockCounting.title')}
        onSubmit={this.onSubmit}
        fields={this.formFields}
        columns={this.columns}
        onExport={this.onExport}
        update={updateReport}
        emptyReportMsg='totalAccuracy.return.filter'
        topLeftPart={() => (
          <Checkbox
            name="includeLot"
            label={translate('rotativeInventory.showBatch')}
            checked={this.state.includeLot}
            onChange={(e) => {
              this.setState({
                includeLot: e,
                updateReport: true,
              })
            }}
          />
        )}
      />
    )
  }
}

const mapStateToProps = ({
  rotativeInventoryReducer,
  paginateReducer,
  reportReducer,
}) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  error: reportReducer.get.error,
  pages: paginateReducer.pages,
  records: rotativeInventoryReducer.records,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...rotativeInventoryActions, ...reportActions },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(TotalAccuracy)
)